import appConstants from "../../../../appConstants";
import { formatESTDateTime } from "../../../dataGrid/gridUtilities";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration();
  }

static actionValueGetter(params){
const {changedBy} = params.data;
const actions = Object.keys(appConstants.ACTION);
if(actions.includes(changedBy)){
      return appConstants.ACTION[changedBy];
    }
    return changedBy;
  }

  static userValueGetter(params) {
    const { firstName, lastName, user } = params.data;

    if (firstName && lastName && firstName.toLowerCase() !== "admin") {
      return (firstName + " " + lastName);
    } else if(user){
      return user.toLowerCase() === "etl" ? "RouteMAX" : user;
    } 
    return ""
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ProHistory,
      keyColumn: "proId",
      defaultColDef: {
        sortable: true
      },
      columns: [
        {
          headerName: "Pro ID",
          field: "proId",
          minWidth: appConstants.columnWidth.PROID
        },
        {
          headerName: "Route Name",
          field: "routeName",
          minWidth: appConstants.columnWidth.ROUTES
        },
        {
          headerName: "Shipment Status",
          field: "shipmentStatus",
          tooltipField: "shipmentStatus",
          minWidth: appConstants.columnWidth.SHIPMENT_STATUS
        },
        {
          headerName: "Action",
          field: "changedBy",
          tooltipValueGetter:GridConfig.actionValueGetter,
          minWidth: appConstants.columnWidth.REPORTS_PRO_CHANGED_BY,
          valueGetter:GridConfig.actionValueGetter
        },
        {
          headerName: "User",
          field: "user",
          tooltipValueGetter: GridConfig.userValueGetter,
          minWidth: appConstants.columnWidth.REPORTS_USER,
          valueGetter: GridConfig.userValueGetter
        },
        {
          headerName: "Timestamp (EST)",
          field: "createdDateTime",
          minWidth: appConstants.columnWidth.TOTAL_TIME,
          valueGetter: params =>
            formatESTDateTime({ value: params.data.createdDateTime })
        }
      ]
    };
  }
}
